import { render, staticRenderFns } from "./GerenciamentoTabelasCargas.vue?vue&type=template&id=1f10495b"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciamentoTabelasCargas.vue?vue&type=style&index=0&id=1f10495b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports